// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Nuq0r","ripple":"styles_ripple__frxXi","dark":"styles_dark__deetk","red":"styles_red__2wDHn","gold":"styles_gold__g-yW-"};